var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.36,14.64l5.52-5.52,.07-.07,4.12-4.12-1.41-1.41-3.29,3.29c-1.1-.26-2.22-.4-3.37-.4-4.19,0-8.2,1.8-11.01,4.93v1.34c1.39,1.54,3.07,2.76,4.91,3.6l-2.39,2.39,1.41,1.41,4.7-4.7h0l.73-.73Zm-2.93,.1c-1.59-.61-3.06-1.54-4.31-2.74,1.55-1.5,3.45-2.56,5.5-3.13-.39,.62-.63,1.35-.63,2.13,0,.89,.3,1.71,.8,2.37l-1.36,1.36Zm15.58-3.41v1.34c-2.81,3.13-6.82,4.93-11.01,4.93-.56,0-1.11-.04-1.66-.11l1.9-1.9c3.22-.06,6.31-1.35,8.64-3.59-.88-.85-1.88-1.54-2.95-2.1l1.47-1.47c1.33,.77,2.56,1.73,3.61,2.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeSlash);
export default __webpack_public_path__ + "static/1768397567/media/icon-eye-slash.6892b23b88a50c3af247ac4a799149c8.svg";
export { ForwardRef as ReactComponent };